import { all } from 'redux-saga/effects';
import sitemap from './sitemap';

export default function* rootSaga() {
  yield all([
    sitemap(),
  ]);
}
